import { startOfMonth, endOfMonth, isSameDay } from "date-fns";
import { store } from "../store";
import {
	OccupiedDay,
	patchOccupiedDay,
	getOccupiedDaysByRange,
	postOccupiedDayNotifyArea
} from "../api/occupied-days";
import {
	updateOccupiedDays,
	updateSingleOccupiedDay,
	deactivateTableLinkMode
} from "./store/app-actions";
import { setSnackbarMessage } from "./store/snackbar-actions";

export const saveTableLinkGroupsAndUpdateStore = async () => {
	const tempTableLinkGroups = store.getState().tempTableLinkGroups;
	let filteredTempTableLinkGroups;

	try {
		filteredTempTableLinkGroups = tempTableLinkGroups.filter(
			group => group.length > 1
		);
	} catch (e) {
		store.dispatch(
			setSnackbarMessage(
				"Tischverbindungen konnten nicht gespeichert werden!",
				"error"
			)
		);
		store.dispatch(deactivateTableLinkMode());

		return;
	}

	if (tempTableLinkGroups.length > filteredTempTableLinkGroups.length) {
		store.dispatch(
			setSnackbarMessage(
				"Eine Tischgruppe benötigt mindestens 2 Tische!",
				"warning"
			)
		);

		return;
	}

	try {
		const updatedOccupiedDay = await saveTableLinkGroups(
			filteredTempTableLinkGroups
		);

		store.dispatch(
			updateSingleOccupiedDay(updatedOccupiedDay.id, updatedOccupiedDay)
		);
		store.dispatch(deactivateTableLinkMode());
	} catch (e) {
		store.dispatch(
			setSnackbarMessage(
				"Tischverbindungen konnten nicht gespeichert werden!",
				"error"
			)
		);
		store.dispatch(deactivateTableLinkMode());
	}
};

export const saveTableLinkGroups = async (tableGroups: string[][]) => {
	const response: OccupiedDay = await patchOccupiedDay(
		store.getState().date,
		{
			linkedTables: tableGroups
		}
	);

	response.date = new Date(response.date);

	return response;
};

export const toggleLockForSelectedDay = async () => {
	const selectedDay = store.getState().date;
	const selectedOccupiedDay = store.getState().occupiedDays.filter(day => {
		return isSameDay(day.date, selectedDay);
	})[0];

	let newLockdown = true;
	if (selectedOccupiedDay && selectedOccupiedDay.lockdown) {
		newLockdown = false;
	}

	const response: OccupiedDay = await patchOccupiedDay(selectedDay, {
		lockdown: newLockdown
	});

	store.dispatch(updateOccupiedDays([response]));
};

export const toggleAreaLockForSelectedDay = async (areaId: string, sendAreaNotifications: boolean) => {
	const selectedDay = store.getState().date;
	const selectedOccupiedDay = store.getState().occupiedDays.filter(day => {
		return isSameDay(day.date, selectedDay);
	})[0];

	let lockedAreas = (selectedOccupiedDay && selectedOccupiedDay.lockedAreas) || [];

	if (lockedAreas.indexOf(areaId) > -1) {
		// Unlock Area
		lockedAreas = lockedAreas.filter(id => id !== areaId);
	} else {
		// Lock Area
		lockedAreas.push(areaId);
		if (sendAreaNotifications) {
			await sendAreaNotificationForSelectedDay(selectedDay, areaId);
		}
	}

	const response: OccupiedDay = await patchOccupiedDay(selectedDay, {
		lockedAreas
	});

	store.dispatch(updateOccupiedDays([response]));
};

export const sendAreaNotificationForSelectedDay = async (date: Date, areaId: string) => {
	await postOccupiedDayNotifyArea(date, areaId);
};

export const getOccupiedDaysForMonthAndUpdateStore = async (
	dateInMonth: Date
) => {
	const from = startOfMonth(dateInMonth);
	const to = endOfMonth(dateInMonth);

	const occupiedDays = await getOccupiedDaysByRange(from, to);
	store.dispatch(updateOccupiedDays(occupiedDays));
};
